import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_EXCURSION_PRICE_URL } from '../apiUrl';

const uploadMasterDataPreviewExcursionPriceApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_EXCURSION_PRICE_URL, data);
};

export default uploadMasterDataPreviewExcursionPriceApi;
